import * as constants from '@/common/constants';
import { get, post, put, del } from '@/utils/http';

/** 更新流程定义 */
export const updProcessDefinition = (processInfo) => {
    return post(constants.API_PROCESS_UPDATE_MODEL, processInfo);
};
/** 获取流程定义列表 */
export const getProcessList = (params) => {
    return new Promise((resolve, reject) => {
        // let params = {};
        get(constants.API_PROCESS_LIST, params).then(res => {
            // resolve({
            //     currentPage: res.start,
            //     pageSize: res.size,
            //     totalPageNum: res.total,
            //     data: res.data
            // });
            resolve(res);
        }).catch(err => {
            reject(err);
        });
    });
};

export const setProcessStatus = (processDefinitionId, status) => {
    return post(constants.API_PROCESS_SETTING_STATUS, { processDefinitionId, status });
};

export const saveProcess = (processInfo) => {
    return post(constants.API_PROCESS_SAVE, processInfo);
};

export const cloneProcessDefinition = (processDefinitionId) => {
    return post(constants.API_PROCESS_CLONE.replace(':processDefinitionId', processDefinitionId));
};

export const deleteProcessDefinition = (processDefinitionId) => {
    return del(constants.API_PROCESS_DELETE.replace(':processDefinitionId', processDefinitionId));
};

export const checkUnPublicedProcessDefinition = (processDefinitionId) => {
    return post(constants.API_PROCESS_DEFINITION_UNPUBLIC_CHECK, { processDefinitionId: processDefinitionId });
};

/** 获取流程编排列表 */
export const getProcessServiceList = (params = { currentPage: 1, pageSize: 10 }) => {
    return get(constants.API_PROCESS_SERVICE_LIST, params);
};
export const getUserProcessServiceDataAuthList = (params) => {
    return get(constants.API_USER_PROCESS_DATA_AUTH_LIST, params);
};

export const getEnableProcessDefinitionList = (currentPage = 1, pageSize = 10) => {
    return get(constants.API_PROCESS_SERVICE_ENABLE_LIST, { currentPage, pageSize });
};

export const saveProcessService = (processInfo) => {
    return post(constants.API_PROCESS_SERVICE_SAVE, processInfo);
};

export const publishProcessService = (processServiceId, deploymentId) => {
    return post(constants.API_PROCESS_SERVICE_PUBLISH.replace(':processServiceId', processServiceId).replace(':deploymentId', deploymentId || '-'));
};

export const publishProcessTemplate = (processTemplate) => {
    return post(constants.API_PROCESS_TEMPLATE_PUBLISH, processTemplate);
};

export const saveProcessTemplate = (templateInfo) => {
    return post(constants.API_PROCESS_TEMPLATE_SAVE, templateInfo);
};

export const deleteProcessService = (processId) => {
    return del(constants.API_PROCESS_SERVICE_DELETE, { id: processId });
};

export const getProcessServiceTemplate = (processServiceId, deploymentId) => {
    return get(constants.API_PROCESS_SERVICE_TEMPLATE.replace(':processServiceId', processServiceId).replace(':deploymentId', deploymentId));
};

export const getServiceTasks = (processServiceId, deploymentId) => {
    return get(constants.API_PROCESS_SERVICE_TASKS.replace(':processServiceId', processServiceId).replace(':deploymentId', deploymentId));
};

export const getProcessServiceConfig = (processServiceId, deploymentId, taskId) => {
    return get(constants.API_PROCESS_SERVICE_ELEMENT_CONFIG.replace(':processServiceId', processServiceId).replace(':deploymentId', deploymentId).replace(':taskId', taskId));
};

export const getProcessServiceInstanceConfig = (processServiceId, deploymentId, taskId, processInstanceId) => {
    return get(constants.API_PROCESS_SERVICE_ELEMENT_INSTANCE_CONFIG.replace(':processServiceId', processServiceId).replace(':deploymentId', deploymentId).replace(':processInstanceId', processInstanceId).replace(':taskId', taskId));
};

export const saveProcessServiceConfig = (element) => {
    return post(constants.API_PROCESS_SERVICE_ELEMENT_SAVE, element);
};

export const getProcessSequenceFlowConfig = (sequenceFlowId, deploymentId) => {
    return get(constants.API_PROCESS_SERVICE_SEQUENCE_FLOW_CONFIG.replace(':sequenceFlowId', sequenceFlowId).replace(':deploymentId', deploymentId));
};

export const getProcessCallActivityConfig = (callActivityId, deploymentId) => {
    return get(constants.API_PROCESS_SERVICE_CALL_ACTIVITY_CONFIG.replace(':callActivityId', callActivityId).replace(':deploymentId', deploymentId));
};

export const getProcessServiceSequenceFlowConditions = (processServiceId, deploymentId) => {
    return get(constants.API_PROCESS_SERVICE_SEQUENCE_FLOW_CONDITIONS.replace(':processServiceId', processServiceId).replace(':deploymentId', deploymentId));
};

export const saveProcessSequenceFlowConfig = (sequenceFlowConfig) => {
    return post(constants.API_PROCESS_SERVICE_SEQUENCE_FLOW_SAVE, sequenceFlowConfig);
};

export const saveProcessCallActivityConfig = (callActivityConfig) => {
    return post(constants.API_PROCESS_SERVICE_CALL_ACTIVITY_SAVE, callActivityConfig);
};

export const getProcessServiceForms = (params) => {
    return post(constants.API_PROCESS_SERVICE_FORMS, params);
};

export const getProcessServiceTaskForms = (params) => {
    return post(constants.API_PROCESS_SERVICE_TASK_FORMS, params);
};

export const getProcessServiceFormsAuth = (params) => {
    return post(constants.API_PROCESS_SERVICE_FORMS_AUTH, params);
};

export const saveProcessServiceFormAuth = (params) => {
    return post(constants.API_PROCESS_SERVICE_SAVE_FORMS_AUTH, params);
};

/** 流程模板 / 已发布的流程 */
export const getProcessTemplateList = (params) => {
    return get(constants.API_PROCESS_PUBLISHED_LIST, params);
};

/** 启动已发布的流程 */
// export const startProcess = (processServiceId, name, deploymentId) => {
//     return post(constants.API_PROCESS_PUBLISHED_START, { processServiceId, name, deploymentId });
// };
export const startProcess = (params) => {
    return post(constants.API_PROCESS_PUBLISHED_START, params);
};

/** 批量发起流程 */
export const bathStartProcess = (params) => {
    return post(constants.API_PROCESS_PUBLISHED_BATCH_START, params);
};

/** 保存表单 */
export const saveProcessInstance = (instanceData) => {
    return post(constants.API_PROCESS_SAVE_INSTANCE.replace(':processInstanceId', instanceData.processInstanceId), instanceData);
};

/** 流程负责人配置 */
export const updProcessAssigneeUser = (instanceData) => {
    return post(constants.API_PROCESS_UPD_PROCESS_ASSIGNEE_USER, instanceData);
};

export const saveProcessInstanceTemplate = (templateInfo) => {
    return post(constants.API_PROCESS_INSTANCE_TEMPLATE_SAVE, templateInfo);
};

export const getProcessInstanceTemplate = (processInstanceId, processServiceId, deploymentId) => {
    return get(constants.API_PROCESS_INSTANCE_TEMPLATE.replace(':processInstanceId', processInstanceId).replace(':processServiceId', processServiceId).replace(':deploymentId', deploymentId));
};

/** 保存审批流 **/
export const saveApprovalTemplate = (template) => {
    return post(constants.API_APPROVAL_TEMPLATE_SAVE, template);
};
/** 删除审批流模板 **/
export const deleteApprovalTemplate = (id) => {
    return del(constants.API_APPROVAL_TEMPLATE_DELETE.replace(':id', id));
};
/** 发布/停用 审批流模板 **/
export const publishApprovalTemplate = (templateId, templateState) => {
    return post(constants.API_APPROVAL_TEMPLATE_PUBLISH.replace(':templateId', templateId).replace(':templateState', templateState));
};
/** 查询审批流列表 **/
export const getApprovalTemplateList = (params) => {
    return get(constants.API_APPROVAL_TEMPLATE_LIST, params);
    //   return new Promise((resolve, reject) => {
    //     get(constants.API_APPROVAL_TEMPLATE_LIST, params).then(res => {
    //         console.log(res);
    //         resolve(res);
    //     }).catch(err => {
    //         reject(err);
    //     });
    // });
};

/** 保存/发起 审批流 */
export const saveApprovalInstance = (instanceData) => {
    return post(constants.API_APPROVAL_INSTANCE_SAVE, instanceData);
};

/** 查询审批流实例列表 **/
export const getApprovalInstanceList = (params) => {
    return post(constants.API_APPROVAL_INSTANCE_LIST, params);
};

/** 获取所有审批流 **/
export const getAllAproveList = (params) => {
    return post(constants.API_ALL_APROVELIST, params);
};

/** 审批通过 */
export const addPassApproval = (param) => {
    return post(constants.API_APPROVAL_INSTANCE_PASS, param);
};

/** 审批驳回 */
export const addRejectApproval = (param) => {
    return post(constants.API_APPROVAL_INSTANCE_REJECT, param);
};

/** 删除审批流实例 **/
export const deleteApprovalInstance = (id) => {
    return del(constants.API_APPROVAL_INSTANCE_DELETE.replace(':id', id));
};
/** 查询审批流记录 **/
export const getApprovalRecordList = (params) => {
    return post(constants.API_APPROVAL_RECORD_LIST, params);
};
/** 查询审批流审批人列表 **/
export const getApprovalInstanceUserListById = (params) => {
    return post(constants.API_APPROVAL_INSTANCE_USER_LIST, params);
};

/** 查询审批通过未还款的表单数据 **/
export const getModelFormInstanceApprovalDurList = (params) => {
    return post(constants.API_APPROVAL_MODELFORM_INSTNCE_DUR_LIST, params);
};

/** 根据表单数据ID查询审批记录 **/
export const getApprovalRecordListByModelInstanceId = (params) => {
    return post(constants.API_APPROVAL_INSTNCE_APPROVAL_RECORD_LIST_BY_MODELINSTANCEID, params);
};

/** 审批驳回 */
export const delWithdrawApproval = (param) => {
    return post(constants.API_APPROVAL_INSTANCE_WITHDRAW, param);
};

/** 推送审批流模板给客服 */
export const copyApprovalTemplateToCs = (approvalTemplateId) => {
    return post(constants.API_APPROVAL_TEMPLATE_PUSH_TO_CS, {approvalTemplateId});
};

/** 根据ID获取审批流实例信息 */
export const getApprovalInstanceDetail = (id) => {
    return get(constants.API_APPROVAL_INSTANCE.replace(':id', id));
};

// 流程中心-时间管理
export const getServiceTimeTemplate = (id) => {
    return get(constants.API_PROCESS_SERVICE_TIME_TEMPLATE_DETAIL.replace(':id', id));
};
export const getServiceTimeTreeList = (params) => {
    return get(constants.API_PROCESS_SERVICE_TIME_TREE_LIST, params);
};
export const saveServiceTimeTreeNode = (treeNode) => {
    return post(constants.API_PROCESS_SERVICE_TIME_TREE_SAVE, treeNode);
};

export const saveServiceTimeTemplate = (timeTemplate) => {
    if (timeTemplate.id === undefined || timeTemplate.id === '') {
        return post(constants.API_PROCESS_SERVICE_TIME_TEMPLATE_SAVE, timeTemplate);
    } else {
        return put(constants.API_PROCESS_SERVICE_TIME_TEMPLATE_UPDATE, timeTemplate);
    }
};

export const getServiceTimeTemplateList = (params) => {
    return get(constants.API_PROCESS_SERVICE_TIME_TEMPLATE_LIST, params);
};

export const deleteServiceTimeTemplate = (id) => {
    return del(constants.API_PROCESS_SERVICE_TIME_TEMPLATE_DELETE.replace(':id', id));
};

export const getServiceTimeTemplateInstance = (id) => {
    return get(constants.API_PROCESS_SERVICE_TIME_TEMPLATE_INSTANCE.replace(':id', id));
};

export const getServiceTimeTreeInstanceList = (params) => {
    return get(constants.API_PROCESS_SERVICE_TIME_TREE_INSTANCE_LIST, params);
};

export const saveServiceTimeTemplateInstance = (timeTemplate) => {
    return post(constants.API_PROCESS_SERVICE_TIME_TEMPLATE_INSTANCE_SAVE, timeTemplate);
};

// export const getServiceTimeTemplateInstanceList = (params) => {
//     return get(constants.API_PROCESS_SERVICE_TIME_TEMPLATE_INSTANCE_LIST, params);
// };

export const deleteServiceTimeTreeNode = (id) => {
    return del(constants.API_PROCESS_SERVICE_TIME_TREE_NODE_DELETE.replace(':id', id));
};

export const deleteServiceTimeInstanceTreeNode = (id, processInstanceId) => {
    return del(constants.API_PROCESS_SERVICE_TIME_INSTANCE_TREE_NODE_DELETE.replace(':id', id).replace(':processInstanceId', processInstanceId));
};

export const getTimeTemplateInstanceForms = (params) => {
    return post(constants.API_PROCESS_SERVICE_TIME_TEMPLATE_INSTANCE_MODELFORMS, params);
};

// 闭环模板
export const saveProcessCloseTemplate = (closeTemplate) => {
    if (closeTemplate.id === undefined || closeTemplate.id === '') {
        return post(constants.API_PROCESS_CLOSE_TEMPLATE_SAVE, closeTemplate);
    } else {
        return put(constants.API_PROCESS_CLOSE_TEMPLATE_UPDATE, closeTemplate);
    }
};

export const saveProcessInstanceCloseTemplate = (closeTemplate) => {
    return post(constants.API_PROCESS_INSTANCE_CLOSE_TEMPLATE_SAVE, closeTemplate);
};

export const getProcessCloseTemplateList = (params) => {
    return get(constants.API_PROCESS_CLOSE_TEMPLATE_LIST, params);
};

export const delProcessCloseTemplate = (id) => {
    return del(constants.API_PROCESS_CLOSE_TEMPLATE_DELETE.replace(':id', id));
};

export const saveProcessCloseTemplateTask = (closeTemplateTask) => {
    if (closeTemplateTask.id === undefined || closeTemplateTask.id === '') {
        return post(constants.API_PROCESS_CLOSE_TEMPLATE_TASK_SAVE, closeTemplateTask);
    } else {
        return put(constants.API_PROCESS_CLOSE_TEMPLATE_TASK_UPDATE, closeTemplateTask);
    }
};

export const getProcessInstanceCloseTemplate = (processInstanceId, id) => {
    return get(constants.API_PROCESS_CLOSE_TEMPLATE.replace(':processInstanceId', processInstanceId).replace(':id', id));
};

export const getProcessCloseTemplateTaskList = (params) => {
    return get(constants.API_PROCESS_CLOSE_TEMPLATE_TASK_LIST, params);
};

export const delProcessCloseTemplateTask = (id) => {
    return del(constants.API_PROCESS_CLOSE_TEMPLATE_TASK_DELETE.replace(':id', id));
};

export const saveProcessServiceUserRelation = (processServiceUserRelationBO) => {
    return post(constants.API_PROCESS_SERVICE_USER_RELATION_SAVE, processServiceUserRelationBO);
};

export const saveAllProcessServiceUserRelation = (processServiceUserRelationBO) => {
    return post(constants.API_ALL_PROCESS_SERVICE_USER_RELATION_SAVE, processServiceUserRelationBO);
};

export const saveProcessServiceUserRelationForCreateBy = (processServiceUserRelationBO) => {
    return post(constants.API_PROCESS_SERVICE_USER_RELATION_SAVE_FOR_CREATEBY, processServiceUserRelationBO);
};

export const cancelAllProcessServiceUserRelation = (processServiceUserRelationBO) => {
    return post(constants.API_ALL_PROCESS_SERVICE_USER_RELATION_CANCEL, processServiceUserRelationBO);
};

export const delProcessInstanceCloseTemplateTask = (id) => {
    return del(constants.API_PROCESS_INSTANCE_CLOSE_TEMPLATE_TASK_DELETE.replace(':id', id));
};

export const addProcessFileReadRecord = (FileBO) => {
    return post(constants.API_PROCESS_FILE_READ_RECORD_ADD, FileBO);
};

export const getProcessFileUnReadCnt = (param) => {
    return post(constants.API_PROCESS_FILE_UN_READ_CNT, param);
};

export const batchUpdProcessFilesStatus = (param) => {
    return post(constants.API_PROCESS_FILE_ALL_UN_READ_TO_READ, param);
};

// 查询应用和流程关系列表
export const getAppProcessList = (param) => {
    return get(constants.API_APPLICATION_PROCESS_LIST, param);
};
/** 获取应用管理的流程定义列表 */
export const getMyProcessDefinitionList = (params) => {
    return new Promise((resolve, reject) => {
        // let params = {};
        get(constants.API_APPLICATION_PROCESS_DEFINITION_LIST_BY_ID, params).then(res => {
            // resolve({
            //     currentPage: res.start,
            //     pageSize: res.size,
            //     totalPageNum: res.total,
            //     data: res.data
            // });
            resolve(res);
        }).catch(err => {
            reject(err);
        });
    });
};
/** 获取商店应用管理的流程定义列表 */
export const getStoreProcessDefinitionList = (params) => {
    return new Promise((resolve, reject) => {
        // let params = {};
        get(constants.API_APPSTORE_APP_PROCESS_DEFINITION_LIST, params).then(res => {
            // resolve({
            //     currentPage: res.start,
            //     pageSize: res.size,
            //     totalPageNum: res.total,
            //     data: res.data
            // });
            resolve(res);
        }).catch(err => {
            reject(err);
        });
    });
};

/**
 * 获取流程实例树
 */
export const getProcessRelateTreeList = (processInstanceId) => {
    return get(constants.API_PROCESS_RELATE_TREE_LIST.replace(':processInstanceId', processInstanceId));
};
/**
 * 获取流程实例树
 */
export const getProjectMainLineTreeList = (searchParams) => {
    return get(constants.API_PROJET_MAIN_LINE_TREE_LIST, searchParams);
};

// 批量授权表单数据
export const saveBatchProcessServiceDataAuth = (params) => {
    return post(constants.API_PROCESS_SERVICE_SAVE_BATCH_DATA_AUTH, params);
};

// 批量取消表单数据
export const deleteBatchProcessServiceDataAuth = (params) => {
    return post(constants.API_PROCESS_SERVICE_DELETE_BATCH_DATA_AUTH, params);
};

/**
 * 获取流程实例树(任务下的子流程也直接挂载到流程上)
 */
export const getComplateProcessTree = (processInstanceId) => {
    return get(constants.API_PROCESS_COMPLATE_TREE.replace(':processInstanceId', processInstanceId));
};

// 流程常用配置相关接口
export const getProcessCommonUseConfigList = (param) => {
    return get(constants.API_PROCESS_COMMON_USE_CONFIG_LIST, param);
};

export const getProcessCommonUseConfigBO = (id) => {
    return get(constants.API_PROCESS_COMMON_USE_CONFIG_DETAIL.replace(':id', id));
};

export const deleteProcessCommonUseConfigBO = (id) => {
    return del(constants.API_PROCESS_COMMON_USE_CONFIG_DELETE.replace(':id', id));
};

export const cancelProcessCommonUseConfigBOByProcesssId = (processInstanceId) => {
    return del(constants.API_PROCESS_COMMON_USE_CONFIG_DELETE_BY_PROCESS_INSTANCE_ID.replace(':processInstanceId', processInstanceId));
};

export const saveProcessCommonUseConfig = (processCommonUseConfigBO) => {
    return post(constants.API_PROCESS_COMMON_USE_CONFIG_SAVE, processCommonUseConfigBO);
};

export const getBcbpmProcessInstanceList = (params) => {
    return post(constants.API_OPERATION_BCBPM_PROCESS_INSTNCE_LIST, params);
};

export const saveTaskFileAuthViewConfig = (taskFileAuthViewBO) => {
    return post(constants.API_PROCESS_TASK_FILE_AUTH_VIEW_TASK_SAVE, taskFileAuthViewBO);
};

export const getTaskFileAuthViewList = (params) => {
    return post(constants.API_PROCESS_TASK_FILE_AUTH_VIEW_TASKLIST_GET, params);
};

export const addApprovalFileViewForProcessByIds = (params) => {
    return post(constants.API_APPROVAL_FILE_VIEW_FOR_PROCESS_BYIDS_ADD, params);
};

export const delApprovalFileViewForProcessByIds = (params) => {
    return post(constants.API_APPROVAL_FILE_VIEW_FOR_PROCESS_BYIDS_DEL, params);
};

/** 根据表单更新审批人，并获取审批模板(国融特定表单) */
export const getApprovalTemplateByFormData = (formData) => {
    return post(constants.API_APPROVAL_TEMPLATE_GET_BY_FORMDATA, formData);
};
/** 根据表单更新审批人，并获取审批模板 */
export const getApprovalTemplateByTaskFormData = (formData) => {
    return post(constants.API_APPROVAL_TEMPLATE_GET_BY_TASK_FORMDATA, formData);
};

/** 查询任务表单最新的一条审批流id **/
export const getLastTaskApprovalInstanceIdByFromId = (params) => {
    return post(constants.API_APPROVAL_INSTANCE_ID_LAST_BY_FORM_ID, params);
};
/** 审批转办 */
export const updateApprovalUser = (param) => {
    return post(constants.API_APPROVAL_UPDATE_USER, param);
};

/** 查询待办实例列表(审批加任务) **/
export const getCarbonCopyInstanceList = (params) => {
    return post(constants.API_CARBONCOPY_INSTANCE_LIST, params);
};

/** 更新抄送为已读 */
export const updCarbonCopy = (param) => {
    return post(constants.API_CARBON_COPY_READ_UPD, param);
};



// WEBPACK FOOTER //
// ./src/data-model/process/process-model.js